import React, { useState, useRef, useEffect } from 'react';
import { FilterIcon, ChevronDownIcon, ChevronUpIcon, CheckIcon } from '../icons';

const FolderFilter = ({ 
  value, 
  onChange, 
  options = [

    { value: 'newest-first', label: 'Newest first' },
    { value: 'oldest-first', label: 'Oldest first' }
  ], 
  className = "",
  placeholder = "All folders"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const selectedOption = options.find(option => option.value === value);

  return (
    <div className={`relative ${className}`}>
      {/* Main Button */}
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between h-[38px] rounded-xl transition-colors hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A]"
      >
        {/* Content Container */}
        <div className="flex items-center" style={{ height: '32px' }}>
          {/* Filter Icon Container */}
          <div 
            className="w-8 h-8 flex items-center justify-center"
          >
            <FilterIcon 
              size={12} 
              className="text-[#7B7B7B] dark:text-[#848484]" 
            />
          </div>
          
          {/* Text */}
          <span 
            className="font-medium mr-2 text-[#121212] dark:text-[#D0D0D0]"
            style={{
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '16px',
              letterSpacing: '-0.1px'
            }}
          >
            {selectedOption?.label || placeholder}
          </span>
        </div>

        {/* Chevron Icon */}
        <div className="flex items-center justify-center pr-2">
          {isOpen ? (
            <ChevronUpIcon size={12} className="text-[#7B7B7B] dark:text-[#848484]" />
          ) : (
            <ChevronDownIcon size={12} className="text-[#7B7B7B] dark:text-[#848484]" />
          )}
        </div>
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div
          ref={dropdownRef}
          className="absolute top-full left-0 mt-1 bg-[#FCFCFC] dark:bg-[#1A1A1A] border border-[#ECECEC] dark:border-[#202020] rounded-lg shadow-lg z-50"
          style={{
            boxShadow: '0 10px 21px -2px rgba(0, 0, 0, 0.05)'
          }}
        >
          {/* Options */}
          <div className="p-2 space-y-1">
            {options.map((option, index) => (
              <button
                key={option.value}
                onClick={() => handleSelect(option)}
                className={`w-full flex items-center hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A] transition-colors ${
                  option.value === value ? 'bg-[#F7F7F7] dark:bg-[#252525]' : ''
                }`}
                style={{
                  height: '32px',
                  paddingLeft: '8px',
                  paddingRight: '8px',
                  paddingTop: '0px',
                  paddingBottom: '0px',
                  borderRadius: '8px'
                }}
              >
                {/* Icon - Always reserve space, show checkmark only for selected */}
                <div className="w-3 h-3 flex items-center justify-center mr-2">
                  {option.value === value ? (
                    <CheckIcon 
                      size={12} 
                      className="text-[#121212] dark:text-[#D0D0D0]" 
                    />
                  ) : null}
                </div>
                
                {/* Text */}
                <span 
                  className="font-medium text-[#121212] dark:text-[#D0D0D0]"
                  style={{
                    fontSize: '12px',
                    fontWeight: 500,
                    lineHeight: '16px',
                    letterSpacing: '-0.1px'
                  }}
                >
                  {option.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FolderFilter;
